(function() {
  function initMonthlyEditPerformance() {
    var section = document.querySelector('.monthly-edit-wrapper');
    if (!section) return;

    var community = section.querySelector('.me-community');
    if (!community) return;

    var saveData = navigator.connection && navigator.connection.saveData;
    var cpuCores = navigator.hardwareConcurrency || 8;
    if (saveData || cpuCores <= 4) {
      section.classList.add('monthly-edit-performance-lite');
    }

    var communityImages = community.querySelectorAll('.me-community-media-image');
    if (!communityImages.length) return;

    for (var i = 0; i < communityImages.length; i += 1) {
      var img = communityImages[i];
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (i > 0 && !img.getAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
    }

    var communityCards = community.querySelectorAll('.me-community-card');
    if (!communityCards.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < communityCards.length; j += 1) {
        communityCards[j].classList.add('me-community-card--active');
      }
      return;
    }

    var cardObserver = new IntersectionObserver(function(entries) {
      for (var k = 0; k < entries.length; k += 1) {
        var entry = entries[k];
        if (entry.isIntersecting) {
          entry.target.classList.add('me-community-card--active');
          cardObserver.unobserve(entry.target);
        }
      }
    }, { rootMargin: '200px 0px', threshold: 0.05 });

    for (var m = 0; m < communityCards.length; m += 1) {
      cardObserver.observe(communityCards[m]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMonthlyEditPerformance);
  } else {
    initMonthlyEditPerformance();
  }
})();
